module.exports = function isArray(x) {
  return Array.isArray ? Array.isArray(x) : x instanceof Array;
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isArray.js
// module id = 390
// module chunks = 0